import React, { useState, Fragment } from "react";
import "../../../../ui-styles/list/contactListAction.css";
import "../../../../ui-styles/inlineLink/inlineLinkIcon.css";
import DeleteAllergy from "./DeleteAllergy";


const ListDrugAlleg = (props) => {
    const [openDelete, setOpenDelete] = useState(false)

    const handleOpen = () => {
        setOpenDelete(true);
    }

    const handleClose = () => {
        setOpenDelete(false);
    }

    return (
        <Fragment>
            <li className="cntcListItem Md" key={props.drugItem.userId}>
                <div className="cntcListIcon">
                    <img src="/images/icons/drug-gray-48.png" alt="avatar" />
                </div>
                <div className="cntcListContent">
                    <span className="elslistTxtL">{decodeURIComponent(props.drugItem.name)}</span>
                    <span className="elslistTxtM">{decodeURIComponent(props.drugItem.description)}</span>
                </div>
                <div className="cntcListAction">
                    <div className="actionItem" onClick={() => props.handleEdit(props.drugItem)}>
                        <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                    </div>
                    <div className="actionItem" onClick={handleOpen}>
                        <img src="/images/icons/delete-outline.png" alt="icon"  className="invertPrimary"/>
                    </div>

                </div>
            </li>
            {openDelete &&
                <DeleteAllergy handleDelete={() => props.delete(props.drugItem.id)} handleClose = {handleClose}  openDelete={openDelete} />}
        </Fragment>
    )
}
export default React.memo(ListDrugAlleg);